import { render } from "./StorageStatusInformation.vue?vue&type=template&id=3499c70b&scoped=true&ts=true"
import script from "./StorageStatusInformation.vue?vue&type=script&lang=ts"
export * from "./StorageStatusInformation.vue?vue&type=script&lang=ts"

import "./StorageStatusInformation.vue?vue&type=style&index=0&id=3499c70b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3499c70b"]])

export default __exports__